"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import NextImage from "next/image";
import { Link } from "@/components/Link/Link.component";
import { useImageConfiguration } from "@/contexts/image-configuration/image-configuration.context";
import type { JobModel } from "@/services/api/content/models/job.model";
import { imageLoader } from "@/utilities/image/image-loader";
import { useTrackJobAdInview } from "@/vendors/Snowplow/hooks/use-track-job-ad-inview.hook";
type JobItemProps = {
  readonly className?: string;
  readonly id: number;
  readonly image: JobModel.Image | null;
  readonly headline: string;
  readonly placement: string;
  readonly targetUrl: string;
};
export function JobItem(t0) {
  const $ = _c(16);
  const {
    className,
    headline,
    id,
    image,
    placement,
    targetUrl
  } = t0;
  let t1;
  if ($[0] !== id || $[1] !== placement) {
    t1 = {
      jobAdId: id,
      placement
    };
    $[0] = id;
    $[1] = placement;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const ref = useTrackJobAdInview(t1);
  const {
    serverUrl
  } = useImageConfiguration();
  let t2;
  if ($[3] !== className) {
    t2 = clsx(["group/job block space-y-1", className]);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== image || $[6] !== serverUrl) {
    t3 = image ? <figure className="relative block h-[60px] max-w-[160px]"><NextImage alt={image.alternativeText} className="h-[60px] w-full object-contain object-left" height="60" loader={imageLoader(serverUrl)} src={image.thumbnailUrl} width="160" /></figure> : null;
    $[5] = image;
    $[6] = serverUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== headline) {
    t4 = <p className="line-clamp-3 text-balance text-[1rem] leading-snug group-hover/job:underline">{headline}</p>;
    $[8] = headline;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== ref || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== targetUrl) {
    t5 = <Link className={t2} href={targetUrl} openInNewTab={true} ref={ref} rel="noreferrer">{t3}{t4}</Link>;
    $[10] = ref;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = targetUrl;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}